import * as React from "react";
import NavigationBar from "../../components/navigation-bar/NavigationBar";
import { APP_NAVE_MENU_ITEMS } from "../../constants/AppEnums";

export default function MainNavMenu(props) {

  return (
    // <Layer>
    // <div
    //   className={css({
    //     boxSizing: "border-box",
    //     width: "100vw",
    //     position: "fixed",
    //     top: "0",
    //     left: "0",
    //   })}
    // >
      <NavigationBar items={APP_NAVE_MENU_ITEMS} />
    // </div>
    // </Layer>
  );
}
